import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

//Constants
import { SELECT_OPTIONS } from '@common-components/form/constants/selectOptions';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';

//Components
import { GIButton } from 'app-components';
import { RenderSearchByNameComponents } from './fragments/renderSearchByNameComponents';
import { RenderSearchBySSNComponents } from './fragments/renderSearchBySSNComponents';
import RadioButton from '@common-components/form/Radio';
import GenericHeader from '@common-components/pageHeader/GenericHeader';
import ErrorMessage from '@common-components/form/errorMessage';

const EDESearch = ({
    values,
    handleChange,
    handleBlur,
    handleFocus,
    handleSubmit,
    clearEDESearch,
    errors,
    resetErrors,
    setEmptyFieldErrMsg,
    isDocumentTypeSSN,
    searchEnrollerByName
}) => {
    const edeSearchOptions = SELECT_OPTIONS.EDE_SEARCH(searchEnrollerByName);
    return (
        <Fragment>
            <GenericHeader
                id='header'
                text='selfDesignation.search.header'
                tag="h1"
                headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
            />
            <div className='gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12' id='ede-search-panel'>
                <div className='grid-row gi-component gi-radio_button__nav-pills'>
                    <fieldset className='usa-fieldset'>
                        <legend className='usa-legend margin-b-10 hidden'>
                            <span className='required-false' aria-hidden='true'>
                                <FormattedMessage id='accounts.accessCode.make_selection'/>
                            </span>
                        </legend>

                        <ul className={'usa-list usa-list--unstyled gi-radio_button__pills'}>
                            {
                                edeSearchOptions.map((option, i) => (
                                    <RadioButton key={i}
                                        label={{
                                            labelClass: ['grid-row', 'gi-radio_button__label'],
                                            showRequiredIcon: false,
                                            labelText: option.text
                                        }}
                                        inputData={{
                                            id: `ede-search_option_${i}`,
                                            isInputRequired: false,
                                            type: INPUT_TYPES.RADIO_BUTTON,
                                            name: 'searchConsumer',
                                            value: option.value,
                                            checked: option.value === values.searchConsumer
                                        }}
                                        errorClasses={['margin-l-0 margin-b-10']}
                                        actions={{
                                            handleFieldChange: (e) => {
                                                setEmptyFieldErrMsg(false);
                                                resetErrors();
                                                clearEDESearch();
                                                handleChange(e);
                                            }
                                        }}
                                    />
                                ))
                            }
                        </ul>
                    </fieldset>
                </div>
                <div className='grid-col-12 gi-radio_button__pills__content'>
                    { values.searchConsumer === 'ssn' &&
                        <RenderSearchBySSNComponents { ...{ values, handleChange, handleBlur, isDocumentTypeSSN } } />
                    }
                    { values.searchConsumer === 'name' &&
                        <RenderSearchByNameComponents { ...{ values, handleChange, handleBlur, handleFocus } } />
                    }

                </div>

                {
                    Object.keys(errors).length > 0 && ['ssn', 'name'].includes(values.searchConsumer) &&
                    <div className="grid-row error__msg--group">
                        { Object.entries(errors).map(([error, obj], index) => {
                            console.error('error', error);
                            return (obj.map((item) => {
                                return (
                                    <ErrorMessage
                                        key={index}
                                        isVisible={true}
                                        messageText={item.errorMsg}
                                        errorWrapperClasses={['grid-col-12']}
                                        errorClasses={[]}
                                    />
                                );
                            }));
                        })}
                    </div>
                }

                <div className='grid-col-12 action__btn__wrapper padding-b-0'>
                    <GIButton id='search-btn' labelId='selfDesignation.search.action-btn.search' onClickHandler={handleSubmit} />
                </div>
            </div>
        </Fragment>
    );
};

export default EDESearch;

